import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { useLocation } from 'react-router-dom';
import Subpart from './Subpart';

const items = ['Apples', 'Bananas', 'Cherries', 'Dates'];

// Custom Option with checkbox
const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => { }}
        style={{ marginRight: 8, cursor: 'pointer' }}
      />
      {props.label}
    </components.Option>
  );
};

// Hide the selected value display
const CustomMultiValue = () => null; // No pills
const CustomValueContainer = ({ children, ...props }) => {
  return (
    <components.ValueContainer {...props}>
      {props.selectProps.placeholder}
    </components.ValueContainer>
  );
};


const CheckboxSelect = ({ options, selectedOptions, setSelectedOptions }) => {
  //    const [selectedOptions, setSelectedOptions] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    console.log(selectedOptions, 'selectedOptions in checkbox select');
  }, [selectedOptions])
  // Custom styles for padding and border radius
  const customStyles = {
    control: (provided) => ({
      ...provided,
      padding: '2px',
      borderRadius: '6px',
      marginTop: '2px',
      border: '1px solid rgb(30 58 138)',
      boxShadow: 'none', // Remove focus border shadow
      '&:hover': {
        border: '1px solid rgb(30 58 138)', // Same as default to prevent change on hover
      },
      // width: location.pathname === '/part-number-search' ? '420px' : '',
      width: location.pathname === '/part-number-search'
        ? (windowWidth <= 500 ? '100%' : '420px')  // Adjust width for mobile screens
        : '353px',

    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      // width: location.pathname === '/part-number-search' ? '400px' : '200px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '300px',  // or any height you want
      overflowY: 'auto',
      whiteSpace: 'nowrap'
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999, // 👈 Ensures proper layering when using menuPortal
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 12px',
      backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
      color: 'black',
      cursor: 'pointer',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black', // ← This line sets the placeholder color to black
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'black', // 👈 Set chevron color to black
      padding: '0px',
      width: '17px',
      '&:hover': {
        color: 'black',        // Keep same color on hover
        backgroundColor: 'transparent', // No background on hover
      },
    }),
  };
  return (
    <>
      {windowWidth <= 500 ? (
        <Select
          options={options.map((option) => ({ value: option.label, label: option.label }))} // Use correct value and label
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option: CheckboxOption,
            MultiValue: CustomMultiValue,
            IndicatorSeparator: () => null,
            // ValueContainer: CustomValueContainer,
          }}
          onChange={(selected) => {
            // When using react-select with isMulti, 'selected' contains ALL currently selected items
            // We need to format them correctly and update state
            if (selected) {
              const formatted = selected.map(item => ({ value: item.label, label: item.label }));
              setSelectedOptions(formatted);
            } else {
              setSelectedOptions([]);
            }
          }}
          value={selectedOptions ? selectedOptions.map(item => ({ value: item.label, label: item.label })) : []}
          placeholder="Sub Part Type"
          styles={customStyles}
          menuPortalTarget={document.body}
        />
      ) : (
        <Subpart options={options} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} />
      )}
    </>
  );
};

export default CheckboxSelect;
